import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Apakah benar tidak ada minimal order?",
    a: "Benar. Kami melayani order satuan (1 pcs) sampai partai besar (ribuan pcs). Untuk order satuan, harga per pcs memang lebih tinggi dibanding order grosir, tapi kualitas yang Anda terima sama persis.",
  },
  {
    q: "Berapa lama waktu pengerjaan?",
    a: "Order satuan biasanya 1–3 hari kerja setelah desain di-approve. Order 50–500 pcs sekitar 4–7 hari kerja. Partai besar (di atas 500 pcs) akan kami estimasi setelah lihat tingkat kerumitan desain dan media yang dibordir.",
  },
  {
    q: "Format file desain apa yang diterima?",
    a: "Kami menerima file vector (.AI, .CDR, .EPS, .PDF, .SVG) maupun gambar resolusi tinggi (.PNG, .JPG min. 300dpi). Jika Anda hanya punya foto logo, tetap kirim saja — tim kami akan bantu redraw dan punching menjadi file siap bordir.",
  },
  {
    q: "Bagaimana sistem keamanan transaksinya?",
    a: "Semua transaksi kami arahkan melalui marketplace terpercaya. Pembayaran Anda di-hold oleh marketplace dan baru dilepas ke kami setelah Anda menerima dan mengkonfirmasi barang. Resi tracking otomatis muncul di akun marketplace Anda.",
  },
  {
    q: "Apakah bisa kirim ke seluruh Indonesia?",
    a: "Ya, kami melayani pengiriman ke 34 provinsi di Indonesia. Anda tinggal pilih ekspedisi favorit Anda di marketplace — reguler, kargo, atau same-day untuk kota tertentu. Ongkir ditanggung pembeli sesuai tarif ekspedisi.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-muted"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
            Pertanyaan Umum
          </span>
          <h2
            data-testid="faq-headline"
            className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
          >
            Hal yang sering ditanyakan.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="space-y-3"
          data-testid="faq-accordion"
        >
          {faqs.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="bg-background border border-border rounded-xl px-6 data-[state=open]:border-primary/40 transition-colors"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${idx}`}
                className="font-heading text-base md:text-lg font-medium text-foreground text-left hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${idx}`}
                className="font-body text-sm md:text-base leading-relaxed text-muted-foreground pb-5"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
